/* global process */
const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getRandomFXData = (time_frame, periods_back) => {
  const endpoint = `/generate-attempt?time_frame=${time_frame}&periods_back=${periods_back}`;
  return handleApiRequest(endpoint, {
    method: 'GET',
    credentials: 'include'
  });
}

export const postAttemptData = (item) => {
  const endpoint = '/generate-attempt';
  return handleApiRequest(endpoint, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(item),
  });
}

export const getRecentAttempts = () => {
  const endpoint = '/retrieve-attempts';
  return handleApiRequest(endpoint, {
    method: 'GET',
    credentials: 'include',
  });
}

export const getUserSettings = () => {
  const endpoint = '/user-settings';
  return handleApiRequest(endpoint, {
    method: 'GET',
    credentials: 'include',
  });
}

export const updateUserSettings = (settings) => {
  const endpoint = '/user-settings';
  return handleApiRequest(endpoint, {
    method: 'PUT',
    credentials: 'include',
    body: JSON.stringify(settings),
  });
}

// --- Authentication API Calls ---

export const loginUser = (credentials) => {
  const endpoint = '/auth/login/';
  return handleApiRequest(endpoint, {
    method: 'POST',
    credentials: 'include', // Important for session cookies
    body: JSON.stringify(credentials), // { username: '...', password: '...' }
  });
}

export const logoutUser = () => {
  const endpoint = '/auth/logout/';
  return handleApiRequest(endpoint, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({}), // Logout might require an empty body POST
  });
}

export const registerUser = (userData) => {
  const endpoint = '/auth/register/';
  return handleApiRequest(endpoint, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(userData), // { username: '...', email: '...', password1: '...', password2: '...' }
  });
}

export const getCurrentUserDetails = () => {
  const endpoint = '/auth/user/';
  return handleApiRequest(endpoint, {
    method: 'GET',
    credentials: 'include',
  });
}

// Helper function to get CSRF token from cookies
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    console.log(`CSRF token found: ${cookieValue}`); // Debug line
    return cookieValue;
}

let cachedCSRFToken = null;
// Helper to fetch CSRF token from backend API response
export const fetchCSRFToken = async () => {
  try {
    const response = await fetch(`${BASE_URL}/csrf-token/`, { 
      credentials: 'include' 
    });
    
    if (response.ok) {
      const data = await response.json();
      return data.csrfToken; // Return the token from the response
    } else {
      console.warn('Failed to fetch CSRF token: HTTP', response.status);
      return null;
    }
  } catch (e) {
    console.warn('Failed to fetch CSRF token:', e);
    return null;
  }
};

const handleApiRequest = async (endpoint, options = {}, _csrfAttempted = false) => {
    try {
        const url = `${BASE_URL}${endpoint}`;
        const headers = {
            'Content-Type': 'application/json',
            ...options.headers,
        };

        console.debug('API DEBUG: Request headers:', headers);
        console.debug('API DEBUG: Request URL:', url);
        
        // Add CSRF token for methods that require it
        const method = options.method || 'GET'; // Default to GET
        if (!['GET', 'HEAD', 'OPTIONS', 'TRACE'].includes(method.toUpperCase())) {
            let csrftoken = getCookie('csrftoken');
            
            // If no token in cookie, fetch it from API
            if (!csrftoken && !_csrfAttempted) {
                csrftoken = await fetchCSRFToken();
            }
            
            if (csrftoken) {
                headers['X-CSRFToken'] = csrftoken;
            } else {
                console.warn('CSRF token not available. Request might fail.');
            }
        }

        const response = await fetch(url, {
            ...options,
            headers: headers, // Use the updated headers object
        });
  
        if (!response.ok) {
            // Try to get error details from response body for better debugging
            let errorBody = null;
            try {
                errorBody = await response.json();
            } catch (e) { /* Ignore if response is not JSON */ }
            
            console.error('API Error Response:', {
                status: response.status,
                statusText: response.statusText,
                body: errorBody,
                url: url,
                options: options
            });
            throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        // Handle cases where logout might return 200 OK with no content
        if (response.status === 204 || response.headers.get('Content-Length') === '0') {
            return null; // Or return an empty object/success indicator
        }
        
        return await response.json();
    } catch (error) {
      console.error(`API request failed: ${error.message}`);
      // Attach response status if available in the error object (from fetch wrapper)
      error.status = error.response?.status;
      throw error;
    }
};